import type {ActionSpec, ActionStruct} from '@cohort/shared/apps/app';
import {z} from 'zod';

export const GetContactAttributesInputSchema = z.object({});
export type GetContactAttributesInput = z.infer<typeof GetContactAttributesInputSchema>;

export const GetContactAttributesOutputSchema = z.object({
  attributes: z.array(
    z.object({
      name: z.string(),
      // Kept as strings: Brevo adds new attribute categories and types over time, and an
      // unknown value must not discard the whole attribute list.
      // Known categories: normal, transactional, category, calculated, global.
      // Known types: text, date, float, id, boolean, multiple-choice, user, tag.
      category: z.string(),
      type: z.string(),
    })
  ),
});
export type GetContactAttributesOutput = z.infer<typeof GetContactAttributesOutputSchema>;

export type GetContactAttributesActionStruct = ActionStruct<
  'get-contact-attributes',
  GetContactAttributesInput,
  GetContactAttributesOutput
>;
export const GetContactAttributesActionSpec: ActionSpec<GetContactAttributesActionStruct> = {
  id: 'get-contact-attributes',
  inputSchema: GetContactAttributesInputSchema,
  outputSchema: GetContactAttributesOutputSchema,
};
